// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const editMutation = graphql`
	mutation ConfigurableBlockEditMutation($input: ConfigurableBlockEditInput!) {
		ConfigurableBlockEdit(input: $input) {
			error
			edge {
				node {
					id
				}
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: editMutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const { error, userEdge } = response.ConfigurableBlockEdit;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, userEdge);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/components/configurable-blocks/mutations/ConfigurableBlockEdit.js